/**
 * A utility module for working with loyalty subscriptions.
 * @module LoyaltyUtils
 */
import { DataModelsSubscriptionStatus, UsersSubscriptionsUserSubscriptionDto } from "@springtree/eva-services-core";

import Constants from "./constants";

const loyaltyUtils = {
  isSubscribedToLoyalty(subs: UsersSubscriptionsUserSubscriptionDto[]) {
    return (
      subs?.find((s) => {
        return (
          s.Subscription?.BackendID === Constants.LOYALTY_PROGRAM_BACKEND_ID &&
          s.Status === DataModelsSubscriptionStatus.Subscribed
        );
      }) ?? !1
    );
  },
};

export default loyaltyUtils;
